import * as React from 'react';

import once from 'lodash/once';

interface EditableTableSettingsProviderProps {
	children: React.ReactNode;
	className?: string;
	bordered?: boolean;
	addButton?: boolean;
	actionColumnProps?: {
		wrapperClassName?: string;
		width?: number | string;
	};
	customError?: (error: string, reload: () => void) => React.ReactNode;
	renderMobile?: (caption: React.ReactNode, text: string | JSX.Element | null | Array<string>) => JSX.Element;
}

interface EditableTableSettingsProviderState extends Omit<EditableTableSettingsProviderProps, 'children'> {
	className?: string;
}

interface EditableTableSettingsProviderContext {
	state: EditableTableSettingsProviderState;
}

export const createEditableTableSettingsContext = once(() =>
	React.createContext({} as EditableTableSettingsProviderContext));
export const useEditableTableSettingsContext = (): EditableTableSettingsProviderContext =>
	React.useContext(createEditableTableSettingsContext());

const EditableTableSettingsProvider: React.FC<EditableTableSettingsProviderProps> = (props: EditableTableSettingsProviderProps) => {
	const {
		children,
		className = 'table-mobile table-auto-scroll',
		actionColumnProps = {
			wrapperClassName: 'text-right table-actions',
			width: '0px',
		},
		...rest
	} = props;
	const Context = createEditableTableSettingsContext();
	const value = {
		state: {
			className,
			actionColumnProps,
			...rest,
		},
	};

	return <Context.Provider value={value}>
		{children}
	</Context.Provider>;
};

export default EditableTableSettingsProvider;
